import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import styled from '@emotion/styled';

import LeftTriangleIcon from '../../../components/Icons/LeftTriangleIcon';
import {
  SegmentedViewControllerViaQueryString,
  SegmentedViewDataViaQueryStrings,
  SegmentedViewViaQueryString,
} from '../../../components/SegmentedView/SegmentedViewViaQueryStrings';
// import { DASHBOARD, MANAGE_POSTED_JOBS } from '../../../routes/routeConstants';
import Applicant from './Applicant/Applicant';
import Interview from './Interview/Interview';
import ManagePostJobHeader from './ManagePostJobHeader';
import Screening from './Screening/Screening';

import { useAppSelector, RootState } from '../../../redux/store';
import { ApplicantsRefreshProvider } from '../../../context/ApplicantRefreshContext';
import { usePostedJobsPage } from '../../../context/PostedJobsPageContext';
import {
  APPLICATION,
} from '../../../routes/routeConstants';
import useGetCreatedJobPosts from '../../../hooks/jobs/useGetCreatedJobPosts';

const segmentedControllerConfig = {
  Applicants: 'Applicants',
  Screening: 'Screening',
  Interview: 'Interview',
};

const ManagePostJobApplicant = () => {
  const navigate = useNavigate();
  const { jobId } = useParams();

  const { authData } = useAppSelector((state) => state.auth);

  const userId = authData?.id;

  const { currentPage, keyword } = usePostedJobsPage();
  const { getCreatedJobPosts, loading } = useGetCreatedJobPosts();

  const perPage = 10;

  useEffect(() => {
    if (userId) {
      getCreatedJobPosts(
        { page: currentPage.toString(), perPage: perPage.toString(), keyword },
        userId
      );
    }
  }, [currentPage, userId, getCreatedJobPosts, keyword]);

  // Retrieve the jobs list from Redux and find the specific job by its id
  const job = useAppSelector((state: RootState) =>
    state.jobsCreatedList.jobData.find((j) => j.id === jobId)
  );

  console.log(job);

  const goBack = () => {
    // If there’s at least one entry in the session history, go back…
    if (currentPage) {
      // navigate(-2);
      navigate(`/${APPLICATION}?page=${currentPage}`);
    } else {
      // …otherwise fall back to your chosen path
      navigate(`/${APPLICATION}`);
    }
  };

  console.log('currentPage', currentPage);

  return (
    <Container>
      <div>
        <NavigationArea onClick={goBack}>
          <LeftTriangleIcon />
          Back
        </NavigationArea>

        {/* Check if the job exists before rendering the header */}
        {job && !loading ? (
          <ManagePostJobHeader
            title={job.title}
            jobDescription={job.jobDescription}
            yearsOfExperience={job.yearsOfExperience}
            pay={job.pay}
            payInterval={job.payInterval}
            id={jobId ? jobId : ''}
          />
        ) : (
          <div>Loading job details...</div>
        )}

        <ApplicantsRefreshProvider>
          <Shell>
            <SegmentedViewViaQueryString
              queryString="Applicants"
              tabName="applicationStage"
            >
              <SegmentedViewControllerViaQueryString
                className="hollow"
                segmentedViewControllerTitle={segmentedControllerConfig}
              />
              <SegmentedViewDataViaQueryStrings
                segmentedViewControllerTitle={segmentedControllerConfig}
              >
                <Applicant jobId={jobId ?? ''} />
                <Screening jobId={jobId ?? ''} />
                <Interview jobId={jobId ?? ''} />
              </SegmentedViewDataViaQueryStrings>
            </SegmentedViewViaQueryString>
          </Shell>
        </ApplicantsRefreshProvider>
      </div>
    </Container>
  );
};

export default ManagePostJobApplicant;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
  padding-top: 3rem;
  width: 100%;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 1rem;
    width: 100%;
    border-radius: 10px;
    background: white;
  }

  @media (max-width: 480px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const NavigationArea = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #2f80ed;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;

  & > svg {
    transition: transform 0.3s ease-in-out;
    transform: translateX(0);
  }

  &:hover > svg {
    transform: translateX(-8px);
  }
`;

const Shell = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-left: 8px;
  padding-right: 8px;
`;
